import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lesson: localStorage.getItem('course_name'),
    classname: localStorage.getItem('class_name'),
    cate: localStorage.getItem('cate'),
    classInfo: { id: 0 },
    class_id: localStorage.getItem('class_id'),
    course_id: localStorage.getItem('course_id'),
    housework_status: false
  },
  mutations: {
    setLesson (state, item) {
      // state.lesson = null
      // state.classname = null
      state.lesson = item.lesson
      state.classname = item.classname
      state.class_id = item.class_id
      state.course_id = item.course_id
    },
    setCate (state, cate) {
      // state.cate = null
      state.cate = cate
    },
    setClassInfo (state, classInfo) {
      // state.classInfo = null
      state.classInfo = classInfo
    },
    setWorkStatus (state, status) {
      state.housework_status = status
    }
  },
  actions: {
    async getClassInfo (context, classId) {
      const res = await axios.post("/base/class/info", {
        class_id: window.localStorage.getItem("class_id"),
      })
      if (res.data.errCode === 0) {
        const classInfo = res.data.data
        context.commit('setClassInfo', classInfo)
      } else {
        const classInfo = {}
        context.commit('setClassInfo', classInfo)
      }


    },
    async getLesson (context, index) {
      const { data: res } = await axios.post("/base/class/list")
      if (res.errCode === 0 && res.data.length) {
        const item = {
          lesson: res.data[index].course_name,
          classname: res.data[index].class_name,
          class_id: res.data[index].class_id,
          course_id: res.data[index].course_id
        }
        context.commit('setLesson', item)
      } else {
        context.commit('setLesson', {})
      }

    },
    getCate (context, cate) {
      // console.log(isCate)
      context.commit('setCate', cate)
    },
    // 作业详情删除作业，作业列表更新
    setHouseworkStatus (context, status) {
      context.commit('setWorkStatus', status)
    }
  },
  modules: {
  },
  plugins: [persistedState({
    storage:window.localStorage,
    reducer(val) {
      return {
        // 存储state中的classInfo
        classInfo:val.classInfo
      }
    }
  })]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js